import React from 'react';
import PropTypes from 'prop-types';
import { Box, Card, CardContent, Typography } from '@mui/material';

import './MaintenanceDashboardBlocks.scss';

const MaintenanceDashboardBlock = ({
  title,
  icon,
  children,
  className = '',
  headerAction,
}) => (
  <Card className={`maintenance-dashboard-block ${className}`}>
    <CardContent>
      <Box className="maintenance-block-header">
        <Box className="maintenance-block-header-main">
          {icon && <Box className="maintenance-block-icon">{icon}</Box>}
          <Typography variant="h6" className="maintenance-block-title">
            {title}
          </Typography>
        </Box>
        {headerAction && (
          <Box className="maintenance-block-header-action">{headerAction}</Box>
        )}
      </Box>
      <Box className="maintenance-block-body">{children}</Box>
    </CardContent>
  </Card>
);

MaintenanceDashboardBlock.propTypes = {
  title: PropTypes.node,
  icon: PropTypes.element,
  children: PropTypes.node,
  className: PropTypes.string,
  headerAction: PropTypes.node,
};

export default MaintenanceDashboardBlock;
